/** @format */
import {useCallback, useEffect} from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames';

import styles from '@styles/brands/brands.module.scss';
import {useCategory} from '@context/CategoryProvider';
import {api} from '@utils/api';
import Loading from '@components/Loading';
const Categories = dynamic(() => import('./categories'));
const Letters = dynamic(() => import('@components/common/letter/Letters'));
const MobileLetter = dynamic(() =>
	import('@components/common/letter/MobileLetter'),
);
const BrandsList = dynamic(() => import('./brandsList'));
const MessageComponent = dynamic(() =>
	import('@components/common/MessageComponent'),
);

const Index = props => {
	const {router, dispatch, state} = props;
	const {categories} = useCategory();

	const filterGetBrandCategories = useCallback(
		async (category, char) => {
			try {
				if (category) {
					const result = await api({
						url: `/categories/filter-getbrand-categories`,
						data: {
							category: category,
							char: char,
						},
						method: 'post',
					});
					if (result.status) {
						dispatch({type: 'set_brand_data', brandData: result.data});
					} else {
						dispatch({type: 'set_brand_data', brandData: []});
					}
				}
			} catch (e) {
				dispatch({type: 'set_brand_data', brandData: []});
			}
		},
		[dispatch],
	);

	useEffect(() => {
		filterGetBrandCategories(state.activeSubChildren, state.charater);
	}, [state.activeSubChildren, state.charater, filterGetBrandCategories]);

	useEffect(() => {
		try {
			const route = router.asPath.split('?');
			let catSlug = '';
			let childrenSlug = getUrlParams('category', router.asPath);
			let char = getUrlParams('alpha', router.asPath);
			if (route && route.length > 0) {
				catSlug = route[0].split('/');
			} else {
				catSlug = router.asPath.split('/');
			}
			catSlug = catSlug[catSlug.length - 1];
			if (
				(!state.activeCategory || catSlug !== state.activeCategory) &&
				categories &&
				categories.length > 0
			) {
				if (catSlug.includes('&')) {
					catSlug = catSlug.split('&');
					catSlug = catSlug[0];
				}

				let subChild = {};
				const findCategory = categories.find(item => {
					return item.slug === catSlug;
				});
				if (findCategory) {
					if (childrenSlug)
						subChild = findCategory.children.find(item => {
							return item.slug === childrenSlug;
						});
					let activeChild = subChild?.slug || findCategory.slug;
					dispatch({
						type: 'initial_data',
						activeCategory: findCategory.slug,
						name: findCategory.Name,
						activeSubChildren: activeChild,
						subChildren: findCategory.children,
						charater: char ? char : 'A',
						category: findCategory,
					});
					if (!char)
						router.replace({
							pathname: router.asPath,
							query: {alpha: 'A'},
							shallow: true,
						});
				}
			}
		} catch (e) {
			dispatch({
				type: 'initial_data',
				activeCategory: state.activeCategory,
				activeSubChildren: state.activeSubChildren,
				subChildren: state.subChildren,
				charater: state.charater,
				category: state.category,
			});
			router.replace({
				pathname: router.asPath,
				query: {alpha: state.charater},
				shallow: true,
			});
		}
	}, [router, categories, state, dispatch]);

	const getUrlParams = (name, url) => {
		var match = RegExp('[?&]' + name + '=([^&]*)').exec(url);
		return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
	};

	const charaterFilter = charater => {
		if (charater !== state.charater) {
			let query = {};
			if (state.activeSubChildren) query['category'] = state.activeSubChildren;
			query['alpha'] = charater;
			router.replace({
				pathname: `/brands/${state.activeCategory}`,
				query,
				shallow: true,
			});
			dispatch({
				type: 'set_charater',
				charater: charater,
			});
		}
	};

	return (
		<div className={classNames('container', styles.allBrandPage)}>
			<h2>Brands Directory</h2>
			<Categories
				styles={styles}
				category={categories}
				state={state}
				dispatch={dispatch}
			/>

			<Letters
				activeFilter={false}
				href={router.asPath + '&alpha='}
				charater={state.charater}
				callBack={charaterFilter}
				position={'relative'}
			/>
			<MobileLetter
				activeFilter={false}
				href={router.asPath + '&alpha='}
				charater={state.charater}
				callBack={charaterFilter}
			/>
			{state.brandData.length > 0 && (
				<BrandsList
					styles={styles}
					brands={state.brandData}
					category={state.activeCategory}
					subCategory={state.activeSubChildren}
				/>
			)}
			{state.brandData.length === 0 && !state.loader && (
				<div className={styles.messageBox}>
					<MessageComponent
						message={'No data available.'}
						messageKey={'warningPeach'}
					></MessageComponent>
				</div>
			)}

			{state.loader && <Loading />}
		</div>
	);
};

export default Index;
